import React from 'react';
import { PinPointIcon, ShopIcon } from '../../../../../utils/svg';
import { useSelector } from 'react-redux';
import { cleanText } from '../../../../../utils/helper';

const DeliveryLocation = () => {
	const { detail } = useSelector((store) => store?.order);
  
	const outlet = detail?.orderItems?.[0];
	const orderType = cleanText(detail?.request_post_datas?.availabilityName);
	
  return (
		<div className={`my-5 overflow-x-hidden ${orderType != 'delivery' && 'hidden'}`}>
			<div className='flex items-center'>
				<ShopIcon className='fill-[var(--rose-violet)]' />
				<div className='ml-3'>
					<p className='text-xs text-gray-500 font-normal'>Lokasi Restoran</p>
					<p className='text-sm text-gray-800 font-semibold pt-1'>{outlet?.storeName}</p>
				</div>
			</div>
			<div className='flex items-center my-5'>
				<PinPointIcon className='fill-[var(--rose-violet)] min-w-7 w-7 h-auto' />
				<div className='ml-3 w-full pr-10'>
					<p className='text-xs text-gray-500 font-normal'>Lokasi Pengantaran</p>
					<p className='text-sm text-gray-800 font-semibold truncate pt-1'>{detail?.address}</p>
				</div>
			</div>
		</div>
	);
};

export default DeliveryLocation;
